import React, { Component } from 'react';
import { connect } from 'react-redux';

import SvgInfoOutline from '../../icons/svgInfoOutline';

import {
  fetchCountries,
} from '../../actions';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyHandle: '',
      emailOnLogin: '',
      submitted: false,
      countriesLoaded: false,
    };
  }

  componentDidMount() {
    const { dispatch, user } = this.props;

    dispatch(fetchCountries())
      .then((res) => {
        if (res.type === 'FETCH_COUNTRIES_SUCCESS') {
          this.setState({ countriesLoaded: true });
        }
      });

    let currencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currencyHandle = user.me.defaults.currencyHandle;
    }

    let emailOnLogin;
    if (user && user.me && user.me.flags && user.me.flags.emailOnLogin) {
      emailOnLogin = user.me.flags.emailOnLogin;
    }

    this.setState({
      currencyHandle,
      emailOnLogin,
    });
  }

  render() {
    const { submitted } = this.state;
    const { user, tempAnon, countries } = this.props;
    const { me } = user;

    if (!user || !user.me.identity) {
      return (null);
    }

    let country;
    if ((me && me.countryHandle) && (countries && countries.length)) {
      country = countries.filter((item) => item['alpha-2'] === me.countryHandle);
    }

    let countryName;
    if (country && country[0] && country[0].name) {
      countryName = country[0].name;
    }

    let address;
    if (me && me.identity && me.identity.address) {
      address = me.identity.address;
    } else if (me && me.identity && me.identity.houseNo && me.identity.street) {
      address = `${me.identity.houseNo} ${me.identity.street}`;
    }

    return (
      <div className="cell panel v2 small-12 medium-12 large-12">
        <div className="panel-label">
          Personal Details
        </div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x">

              <div className="cell small-6 medium-9 large-9">
                <div className="grid-x group">
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">Postal Address</div>
                  </div>
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">
                      <span className={tempAnon ? 'eyeblur' : ''}>
                        {address}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cell small-6 medium-3 large-3">

              </div>

            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <hr />
          </div>

          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x">

              <div className="cell small-6 medium-9 large-9">
                <div className="grid-x group">
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">Postal / ZIP Code</div>
                  </div>
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">
                      <span className={tempAnon ? 'eyeblur' : ''}>
                        {me.identity.zipCode}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cell small-6 medium-3 large-3">

              </div>
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <hr />
          </div>

          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x">

              <div className="cell small-6 medium-9 large-9">
                <div className="grid-x group">
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">City</div>
                  </div>
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">
                      <span className={tempAnon ? 'eyeblur' : ''}>
                        {me.identity.city}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cell small-6 medium-3 large-3">

              </div>
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <hr />
          </div>

          <div className="cell small-12 medium-12 large-12">
            <div className="grid-x">

              <div className="cell small-6 medium-9 large-9">
                <div className="grid-x group">
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">Country</div>
                  </div>
                  <div className="cell small-12 medium-6 large-6">
                    <div className="">
                      <span className={tempAnon ? 'eyeblur' : ''}>
                        {countryName}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cell small-6 medium-3 large-3">

              </div>
            </div>
          </div>

          <div className="cell small-12 medium-12 large-12">
            <div className="mute" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 32}}>
              <SvgInfoOutline style={{height: 20, width: 20, marginRight: 4}} />
              To change your address, please contact our customer support.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  tempAnon: state.user.tempAnon,
  countries: state.status.countries,
});

export default connect(mapStateToProps)(Account);
